import CircleLoader from '@components/CircleLoader'
import classNames from 'classnames'
import './styles.scss'

const CardSection = ({ children, title, loading, disabled, className, header, activeSelected, notActive }) => (
    <div
        className={classNames('card-section', {
            'is-loading': loading,
            disabled: disabled,
            activeSelected: activeSelected,
            notActive: notActive,
            [className]: !!className,
        })}>
        {header && (
            <div className="d-flex justify-content-start">
                {title && <h4 className="card-section__title mr-auto">{title}</h4>}
                {header && header()}
            </div>
        )}
        {!disabled && <div className="card-section__content">{loading ? <CircleLoader /> : children}</div>}
    </div>
)

CardSection.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    activeSelected: PropTypes.bool,
    notActive: PropTypes.bool,
}

export { CardSection }
